// eslint-disable-next-line no-shadow
enum BoxResult {
  YES
}

export default BoxResult;
